/* B-Selfie wishlist — localStorage, no app. Cards on /pages/preferiti are rendered by the Section Rendering API. */
(function () {
  if (window.__bsWishlist) return; window.__bsWishlist = true; // guard: script must run once even if included twice
  var KEY = 'bs_wishlist';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) { var l = read(); var i = l.indexOf(h); if (i === -1) l.unshift(h); else l.splice(i, 1); write(l); return i === -1; }
  function paint() {
    var list = read();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var on = list.indexOf(b.dataset.handle) !== -1;
      var pressed = on ? 'true' : 'false', label = on ? b.dataset.labelRemove : b.dataset.labelAdd;
      if (b.getAttribute('aria-pressed') !== pressed) b.setAttribute('aria-pressed', pressed);
      if (b.getAttribute('aria-label') !== label) b.setAttribute('aria-label', label);
      var lab = b.querySelector('.wishlist-toggle__label'); if (lab && lab.textContent !== label) lab.textContent = label;
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (c) {
      var n = String(list.length); if (c.textContent !== n) c.textContent = n;
      if (c.hidden !== (list.length === 0)) c.hidden = list.length === 0;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.dataset.handle); paint();
    var page = document.querySelector('[data-wishlist-page]'); if (page) render(page);
  });
  function render(page) {
    var list = read(); var grid = page.querySelector('[data-wishlist-grid]'); var empty = page.querySelector('[data-wishlist-empty]');
    grid.innerHTML = ''; empty.hidden = list.length > 0;
    if (!list.length) return;
    var root = page.dataset.root || '/';
    list.forEach(function (h) {
      var li = document.createElement('li'); li.className = 'grid__item wishlist__item'; grid.appendChild(li);
      fetch(root + 'products/' + h + '?section_id=wishlist-card').then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var card = d.querySelector('.card-wrapper');
        if (card) { li.appendChild(card); } else { li.remove(); var l = read(); var i = l.indexOf(h); if (i !== -1) { l.splice(i, 1); write(l); } }
        paint();
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { paint(); var page = document.querySelector('[data-wishlist-page]'); if (page) render(page); });
  document.addEventListener('shopify:section:load', paint);
  // re-paint only when new toggle buttons are added (ajax grids, quick view); debounced, never on our own writes
  var t = null;
  var mo = new MutationObserver(function (muts) {
    var added = muts.some(function (m) { return Array.prototype.some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('[data-wishlist-toggle]') || n.querySelector('[data-wishlist-toggle]')); }); });
    if (!added) return;
    clearTimeout(t); t = setTimeout(paint, 50);
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
